import cx from 'classnames';
import React, {
	useCallback,
	useContext,
	useEffect,
	useRef,
	useState
} from 'react';

import PropTypes from 'prop-types';
import { logError } from '@culture/common-helpers/logger';
import SizeDependedBlock from 'components/SizeDependedBlock';

import Icon from 'components/Icon';
import { PVIContext } from 'contexts/PVIContext';
import AuthButton from './components/buttons/Auth';
import SearchButton from './components/buttons/Search';
import MobileMenu from './components/MobileMenu';

import styles from './styles.module.scss';

const UserMenu = (props) => {
	const { tabIndex, headerRef } = props;
	const { pviInstance } = useContext(PVIContext);
	const [canShowMobileMenu, setCanShowMobileMenu] = useState(true);
	const ref = useRef(null);

	const onSearchShow = useCallback(() => {
		setCanShowMobileMenu(false);
	}, []);

	const onSearchClose = useCallback(() => {
		setCanShowMobileMenu(true);
		headerRef.current.focus();
	}, []);

	useEffect(() => {
		if (
			ref?.current &&
			pviInstance?._elements &&
			ref?.current !== pviInstance?._elements?.item(0)
		) {
			try {
				pviInstance.resetElements();
			} catch (err) {
				logError(err);
			}
		}
	}, [ref]);

	return (
		<div>
			<div className={styles.inner}>
				<div className={styles.block}>
					<button
						ref={ref}
						type="button"
						className={cx('pvi-open', styles.iconContainer)}
						tabIndex={tabIndex}
						title="Версия для слабовидящих"
						aria-label="Версия для слабовидящих"
					>
						<Icon icon="eye" className={styles.pviIcon} />
					</button>
					<SearchButton
						onClick={onSearchShow}
						onRequestClose={onSearchClose}
						tabIndex={tabIndex}
					/>
				</div>

				<SizeDependedBlock>
					<div className={styles.block}>
						<MobileMenu
							canShow={canShowMobileMenu}
							parentTabIndex={tabIndex}
							{...props}
						/>
					</div>
					<div className={cx(styles.block, styles.hide_mobile)}>
						<AuthButton {...props} />
					</div>
				</SizeDependedBlock>
			</div>
		</div>
	);
};

UserMenu.propTypes = {
	changeTabIndex: PropTypes.func,
	headerRef: PropTypes.object,
	tabIndex: PropTypes.number
};

export default UserMenu;
